import { render, staticRenderFns } from "./labeled-switch.vue?vue&type=template&id=46c9b871"
import script from "./labeled-switch.vue?vue&type=script&lang=js"
export * from "./labeled-switch.vue?vue&type=script&lang=js"
import style0 from "./labeled-switch.vue?vue&type=style&index=0&id=46c9b871&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports